import React from 'react';
import * as commonLogic from '../../../logic/CommonLogic';
import { GLOBAL_MENU_LINKS } from '../../../constants/common/GlobalMenuLinks';

/**
 * GlobalMenu
 */
class GlobalMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openTab: null,
      activeTab: null,
      isMobileModalOpen: false,
      browserThemeValue: commonLogic.getBrowseThemeColor(),
    };
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleMobilePageOpenClick = this.handleMobilePageOpenClick.bind(this);
    this.handleMobilePageCloseClick = this.handleMobilePageCloseClick.bind(this);
    this.tapHereMobileQRIconSrc = `/img/${TAP_HERE_MOBILE_QR}`;
    this.modalContentWidth = 550;
    this.modalContentHeight = 300;

  }

  componentDidMount() {
    const currentPath = window.location.pathname;
    if (currentPath === '/' || currentPath === '') {
      this.setState({ activeTab: 0 });
    } else {
      GLOBAL_MENU_LINKS.forEach((tab, index) => {
        tab.links.forEach((link) => {
          if (link.url.startsWith(currentPath)) {
            this.setState({ activeTab: index });
          }
        });
      });
    }
  }

  handleMouseEnter(id) {
    this.setState({ openTab: id });
  }

  handleMouseLeave() {
    this.setState({ openTab: null });
  }

  handleMobilePageOpenClick() {
    const contentOverlayView = document.getElementById('content_overlay_view_header');
    contentOverlayView.classList.remove('content_overlay_view_style_none');
    contentOverlayView.addEventListener('click', this.handleMobilePageCloseClick, true);

    this.setState({ isMobileModalOpen: true });

    contentOverlayView.style.display = 'block';

    setTimeout(() => {
      const modalContent = document.getElementById('tap_here_mobile_qr_modal');

      const top = $(window).height() / 2 - this.modalContentHeight / 2;
      const left = $(window).width() / 2 - this.modalContentWidth / 2;

      modalContent.style.top = top + 'px';
      modalContent.style.left = left + 'px';

      contentOverlayView.classList.add('content_overlay_view_style_block');

      modalContent.style.visibility = 'visible';
    }, 10);

  }

  handleMobilePageCloseClick() {
    const modalContent = document.getElementById('tap_here_mobile_qr_modal');
    modalContent.style.visibility = 'hidden';

    const contentOverlayView = document.getElementById('content_overlay_view_header');

    contentOverlayView.classList.remove('content_overlay_view_style_block');
    contentOverlayView.removeEventListener('click', this.handleMobilePageCloseClick, true);

    this.setState({ isMobileModalOpen: false });

    contentOverlayView.style.display = 'none';

    setTimeout(() => {
      contentOverlayView.classList.add('content_overlay_view_style_none');
    }, 10);
  }


  handleChangeTheme() {
    let browserThemeValueNew = '';
    if (this.state.browserThemeValue == 'light') {
      browserThemeValueNew = 'dark';
    } else {
      browserThemeValueNew = 'light';
    }

    this.setState({ browserThemeValue: browserThemeValueNew });
    commonLogic.changeTheme();
  }

  render() {
    const { openTab, activeTab, isMobileModalOpen } = this.state;

    let defaultChecked = '';
    if (this.state.browserThemeValue == 'dark') {
      defaultChecked = 'checked';
    }

    return (
      <div id="global_header">
        <div id="content_overlay_view_header" />
        {isMobileModalOpen && (
          <div className="modal_overlay" onClick={this.handleMobilePageCloseClick}>
            <div id="tap_here_mobile_qr_modal" className="tap_here_mobile_qr_modal" onClick={e => e.stopPropagation()}>
              <p className="tap_here_mobile_qr_modal_title">スマートフォンは、以下のQRコードからアクセスしてください。</p>
              <div>
                <img className="tap_here_mobile_qr_modal_image" src={this.tapHereMobileQRIconSrc} alt="スマートフォンからのアクセスはこちら" />
              </div>
              <button onClick={this.handleMobilePageCloseClick} className="modal_close_button">閉じる</button>
            </div>
          </div>
        )}

        <div className="global_menu">
          <ul className="nav_content">
            {GLOBAL_MENU_LINKS.map((tab, index) => (
              <li
                key={index}
                className={`tab ${openTab === index ? 'open' : ''} ${activeTab === index ? 'active' : ''}`}
                onMouseEnter={() => this.handleMouseEnter(index)}
                onMouseLeave={this.handleMouseLeave}
              >
                <a href={tab.links[0].url} className="tab-title">
                  {tab.category}
                  <span className="arrow_down_menu" />
                </a>
                <ul className={`tab-content ${openTab === index ? 'show' : ''}`}>
                  {tab.links.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      <a href={link.url} className="dropdown-item">
                        {link.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>

          {/* FIXME: フェーズ2で対応 */}
          {/* <ul className="nav_content info_link">
            <li>
              <a href="https://www.kccs.co.jp/" target="_blank" rel="noreferrer">
                <span className="import_contacts" />
                ユーザーガイド
              </a>
            </li>
            <li>
              <a href="/pdf/riyoukiyaku.pdf" target="_blank">
                <span className="description" />
                利用規約
              </a>
            </li>
            <li>
              <a href="/pdf/dousakankyou.pdf" target="_blank">
                <span className="personal_video"/>
                動作環境一覧
              </a>
            </li>
          </ul> */}

          <ul className="nav_content">
            <p className="browser_theme_toggle_title">ダーク</p>
            <div id="browser_theme_toggle" className="toggleswitchTheme">
              <input type="checkbox" name="toggle_switch_theme" id="browser_theme_toggle_change" defaultValue={'0'} checked={defaultChecked} onClick={() => this.handleChangeTheme()} readOnly />
              <label htmlFor="browser_theme_toggle_change" className={this.state.browserThemeValue == 'dark' ? 'switch-on' : 'switch-off'}>{this.state.browserThemeValue == 'dark' ? 'ON' : 'OFF'}</label>
            </div>
            <div id="tap_here_mobile_area" className="tap_here_mobile_area" onClick={() => this.handleMobilePageOpenClick()}>
              <span className="tap_here_mobile_icon" />
              <p className="tap_here_mobile_text">スマートフォンからの<br />アクセスはこちら</p>
            </div>
          </ul>

        </div>
      </div>
    );
  }
}

export default GlobalMenu;
